import { render } from "./C4General.vue?vue&type=template&id=6df452d3"
import script from "./C4General.vue?vue&type=script&lang=js"
export * from "./C4General.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__